import * as r from "react";
import i from "../lib/IconBase.es.js";
import c from "../defs/ArrowCircleRight.es.js";
const o = r.forwardRef((e, t) => /* @__PURE__ */ r.createElement(i, { ref: t, ...e, weights: c }));
o.displayName = "ArrowCircleRightIcon";
const s = o;
export {
  s as ArrowCircleRight,
  o as ArrowCircleRightIcon
};
